export default {
    name: 'QTabs',
    props: {
        tabs: {
            type: Array,
            default: [{ name: 'tab', text: 'tab' }]
        },
        selectedTab: {
            type: String,
            default: ''
        }
    },
    created() {
        // select first tab in array unless selectedTab prop was passed in
        this.selectedTab = this.selectedTab || this.tabs[0].name;
    },
    methods: {
        selectTab(tab) {
            // emit selected tab so parent component can perform logic
            this.$emit('selectTab', tab.name);
            this.selectedTab = tab.name;
        }
    }
};
